/**
 * Hauptfunktion/Zusatzfunktion slot invariant (client side): the same
 * OrgFunction must never sit in both slots. The backend enforces the same
 * rule on every write path; keeping the form state and picker options clean
 * makes the invariant visible while editing instead of only after saving.
 */

export function secondaryRolesWithoutMainRole(
  secondaryRoles: readonly string[] | undefined,
  mainRole: string | undefined
): string[] {
  const roles = secondaryRoles ?? [];
  return mainRole ? roles.filter((id) => id !== mainRole) : [...roles];
}

export function secondaryRoleOptionsExcludingMainRole<TOption extends { value: string }>(
  options: readonly TOption[],
  mainRole: string | undefined
): TOption[] {
  return mainRole ? options.filter((option) => option.value !== mainRole) : [...options];
}
